<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="矿业服务配置列表" name="1">
      <KyzxfwAdd :updataID='updataID'></KyzxfwAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 矿业咨询服务修改
 */
import KyzxfwAdd from '../../../../static/form/KyzxfwAdd.vue'
export default {
  components: {
    KyzxfwAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Kyzxfwgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/KyzxfwUpdate.vue